import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { 
  GET_VENDOR_CATS, 
  // GET_ADMIN_PROFILE,
  ADD_NEW_VENDOR_CAT,
  UPDATE_VENDOR_CAT,
  DELETE_VENDOR_CAT
 } from "./actionTypes";
import {
  getVendor_catsSuccess,
  getVendor_catsFail,
  addVendor_catSuccess,
  addVendor_catFail,
  updateVendor_catSuccess,
  updateVendor_catFail,
  deleteVendor_catSuccess,
  deleteVendor_catFail,
  // getVendor_catProfileSuccess,
  // getVendor_catProfileFail,
} from "./actions";

//Include Both Helper File with needed methods
import { 
  getVendor_cats,
  // getVendor_catProfile,
  addNewVendor_cat,
  updateVendor_cat,
  deleteVendor_cat,
} from "../../helpers/backend_helper";
import { showPopup } from "../popup/actions";

function* fetchVendor_cats({payload : {is_active,offset,page_size}}) {
  try {
    const response = yield call(getVendor_cats,{is_active,offset,page_size});
    yield put(getVendor_catsSuccess(response));
  } catch (error) {
    yield put(getVendor_catsFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onUpdateVendor_cat ({payload: ceremony }) {
  try {
    let response = yield call(updateVendor_cat, ceremony);
   if(response.file_src || ceremony.removeImage) ceremony.image = response.file_src

    yield put(updateVendor_catSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(updateVendor_catFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onDeleteVendor_cat({ payload: ceremony }) {
  
  try {
   const response =  yield call(deleteVendor_cat, ceremony);
    yield put(deleteVendor_catSuccess(ceremony));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(deleteVendor_catFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}

function* onAddNewVendor_cat({ payload: ceremony }) {
  try {
    const response =  yield call(addNewVendor_cat, ceremony);
    yield put(addVendor_catSuccess(response.data));
    yield put(showPopup({title:response.message,success:true}));

  } catch (error) {
    yield put(addVendor_catFail(error));
      yield put(showPopup({title:error.response.data.message,error:true}));

  }
}


// function* fetchVendor_catProfile() {
//   try {
//     const response = yield call(getVendor_catProfile);
//     yield put(getVendor_catProfileSuccess(response));
//   } catch (error) {
//     yield put(getVendor_catProfileFail(error));
//   }
// }

function* ceremonysSaga() {
  yield takeEvery(GET_VENDOR_CATS, fetchVendor_cats);
  yield takeEvery(ADD_NEW_VENDOR_CAT, onAddNewVendor_cat);
  yield takeEvery(UPDATE_VENDOR_CAT, onUpdateVendor_cat);
  yield takeEvery(DELETE_VENDOR_CAT, onDeleteVendor_cat);
  // yield takeEvery(GET_ADMIN_PROFILE, fetchVendor_catProfile);
}

export default ceremonysSaga;
